/**
 * @generated SignedSource<<b2be99cb8ceed5d77cedb2d7ea76c5cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CountrySort = "ID" | "NAME" | "ISO_CODE_TWO" | "ISO_CODE_THREE" | "CONTINENT_NAME" | "CURRENCY" | "CURRENCY_SYMBOL" | "STRIPE_SUPPORTED" | "CREATED_AT" | "MIN_TIMEZONE_OFFSET" | "MAX_TIMEZONE_OFFSET" | "RANDOM" | "%future added value";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type CountryOrdering = {
  sort: CountrySort;
  direction: SortDirection;
};
export type CountryFilter = {
  search?: string | null;
  where?: CountryWhere | null;
};
export type CountryWhere = {
  id?: IDFilter | null;
  name?: StringFilter | null;
  isoCodeTwo?: StringFilter | null;
  isoCodeThree?: StringFilter | null;
  continentName?: StringFilter | null;
  currency?: StringFilter | null;
  currencySymbol?: StringFilter | null;
  stripeSupported?: BooleanFilter | null;
  createdAt?: TimeFilter | null;
  minTimezoneOffset?: FloatFilter | null;
  maxTimezoneOffset?: FloatFilter | null;
  regions?: RegionWhere | null;
  or?: CountryWhere | null;
  and?: CountryWhere | null;
};
export type IDFilter = {
  isNull?: boolean | null;
  notNull?: boolean | null;
  equalTo?: string | null;
  notEqualTo?: string | null;
  in?: ReadonlyArray<string> | null;
  notIn?: ReadonlyArray<string> | null;
};
export type StringFilter = {
  isNullOrEmpty?: boolean | null;
  isEmpty?: boolean | null;
  isNull?: boolean | null;
  notNullOrEmpty?: boolean | null;
  notEmpty?: boolean | null;
  notNull?: boolean | null;
  equalTo?: string | null;
  notEqualTo?: string | null;
  in?: ReadonlyArray<string> | null;
  notIn?: ReadonlyArray<string> | null;
  startWith?: string | null;
  notStartWith?: string | null;
  endWith?: string | null;
  notEndWith?: string | null;
  contain?: string | null;
  notContain?: string | null;
  startWithStrict?: string | null;
  notStartWithStrict?: string | null;
  endWithStrict?: string | null;
  notEndWithStrict?: string | null;
  containStrict?: string | null;
  notContainStrict?: string | null;
};
export type BooleanFilter = {
  isNull?: boolean | null;
  notNull?: boolean | null;
  equalTo?: boolean | null;
  notEqualTo?: boolean | null;
};
export type TimeFilter = {
  isNull?: boolean | null;
  notNull?: boolean | null;
  equalTo?: any | null;
  notEqualTo?: any | null;
  lessThan?: any | null;
  lessThanOrEqualTo?: any | null;
  moreThan?: any | null;
  moreThanOrEqualTo?: any | null;
};
export type FloatFilter = {
  isNullOrZero?: boolean | null;
  isNull?: boolean | null;
  notNullOrZero?: boolean | null;
  notNull?: boolean | null;
  equalTo?: number | null;
  notEqualTo?: number | null;
  lessThan?: number | null;
  lessThanOrEqualTo?: number | null;
  moreThan?: number | null;
  moreThanOrEqualTo?: number | null;
  in?: ReadonlyArray<number> | null;
  notIn?: ReadonlyArray<number> | null;
};
export type RegionWhere = {
  id?: IDFilter | null;
  name?: StringFilter | null;
  createdAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  deletedAt?: TimeFilter | null;
  country?: CountryWhere | null;
  or?: RegionWhere | null;
  and?: RegionWhere | null;
};
export type countryCountriesQuery$variables = {
  first: number;
  after?: string | null;
  ordering?: ReadonlyArray<CountryOrdering> | null;
  filter?: CountryFilter | null;
};
export type countryCountriesQuery$data = {
  readonly countries: {
    readonly edges: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"countryCountriesFragment">;
    } | null> | null;
  };
};
export type countryCountriesQuery = {
  variables: countryCountriesQuery$variables;
  response: countryCountriesQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ordering"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "ordering",
    "variableName": "ordering"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "countryCountriesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "CountryConnection",
        "kind": "LinkedField",
        "name": "countries",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CountryEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "countryCountriesFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "countryCountriesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "CountryConnection",
        "kind": "LinkedField",
        "name": "countries",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CountryEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Country",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isoCodeTwo",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isoCodeThree",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "continentName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currencySymbol",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Region",
                    "kind": "LinkedField",
                    "name": "regions",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dab1026700f1132d048ce3528ee4771a",
    "id": null,
    "metadata": {},
    "name": "countryCountriesQuery",
    "operationKind": "query",
    "text": "query countryCountriesQuery(\n  $first: Int!\n  $after: String\n  $ordering: [CountryOrdering!]\n  $filter: CountryFilter\n) {\n  countries(first: $first, after: $after, ordering: $ordering, filter: $filter) {\n    edges {\n      ...countryCountriesFragment\n    }\n  }\n}\n\nfragment countryCountriesFragment on CountryEdge {\n  node {\n    id\n    name\n    isoCodeTwo\n    isoCodeThree\n    continentName\n    currency\n    currencySymbol\n    regions {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a48d48a79883bf0d23a109856d2f9fab";

export default node;
